import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatConnectedDialogRef } from 'src/app/shared/service/connected-dialog';

@Component({
  selector: 'app-cashback-redemption',
  standalone: true,
  imports: [CSButtonComponent, CSIconButtonComponent, PipesModule],
  templateUrl: './cashback-redemption.component.html',
  styleUrl: './cashback-redemption.component.scss',
})
export class CashbackRedemptionComponent {
  constructor(
    private dialogRef: MatConnectedDialogRef<CashbackRedemptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  close() {
    this.dialogRef.close();
  }
}
